import { Permission } from 'api';
import { getBulkActionsRoutes } from './bulkActions';
import { getExaminerRoutes } from './examiner';
import { getExaminersRoutes } from './examiners';
import { getReportsRoutes } from './reports';
import { getUsersRoutes } from './users';
import { RouteDefinition } from './types';

export const ROUTING_PATHS = {
  welcome: '/',
  logout: '/logout',
  loginCallback: '/callback',
  dashboard: {
    to: '/dashboard',
    path: '/dashboard',
    requiresAll: [Permission.ViewDashboard],
  } as RouteDefinition,
  examiners: { ...getExaminersRoutes('/examiners') },
  examiner: {
    ...getExaminerRoutes('/examiners/:examinerId'),
  },
  users: {
    ...getUsersRoutes('/users'),
  },
  reports: {
    ...getReportsRoutes('/reports'),
  },
  bulkActions: {
    ...getBulkActionsRoutes('/bulkActions'),
  },
};
